import React, { Component } from 'react';
import { Circle, Map, TileLayer } from 'react-leaflet-universal';

class Modalmap extends Component {
  constructor() {
    super();
    this.state = {
      showMap: false
    };
  }

  componentDidMount() {
    // let L;
    //
    // L = require('leaflet');
    // require('leaflet-draw');
    // this.setState({ showMap: true });
  }

  componentDidUpdate() {
    // let center = [17.385044, 78.486671];
    // //document.getElementById('map-layer').innerHTML = "<div id='mapp' className='mapp'></div>";
    // // Create the map
    // let map = L.map('mapp').setView(center, 16);
    //
    // // Set up the OSM layer
    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
    //   maxZoom: 18
    // }).addTo(map);
    //
    // let circleCenter = [17.385044, 78.486671]; // Center of the circle
    // // Circle options
    // let circleOptions = {
    //   color: 'red',
    //   fillColor: '#f03',
    //   fillOpacity: 1,
    //   radius: 5
    // };
    //
    // // Creating a circle
    // var circle = L.circle(circleCenter, circleOptions);
    // circle.addTo(map); // Adding circle to the map
  }

  render() {
    return (
      <div>
        <div className="map-header">
          <h5> Lugar de conexión </h5>
          <span className="">Conductor:</span>
          <span className="">Jorge Felipe Quiroz,</span>
          <span className="">Vehiculo:</span>
          <span className="">HGBF32</span>
          <span className="">Fecha asignacion:</span>
          <span className="">20/20/2019</span>
        </div>
        <div className="map-container">
          <div className="map-wrap">
            <div id="map-layer">map</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modalmap;



// WEBPACK FOOTER //
// ./source/client/components/assignment_list/modalMap.jsx